var _defs, _style, _g, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 18",
    width: 30,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0L21 0C25.98 0 30 4.02 30 9L30 9C30 13.98 25.98 18 21 18L9 18C4.02 18 0 13.98 0 9L0 9C0 4.02 4.02 0 9 0Z"
  })), /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 20,
    id: "img1",
    href: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTkuNSIgaGVpZ2h0PSIxOS41IiB2aWV3Qm94PSIwIDAgMTkuNSAxOS41Ij4NCiAgPGRlZnM+DQogICAgPGZpbHRlciBpZD0iT3ZhbCIgeD0iMCIgeT0iMCIgd2lkdGg9IjE5LjUiIGhlaWdodD0iMTkuNSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIj4NCiAgICAgIDxmZU9mZnNldCBkeT0iMiIgaW5wdXQ9IlNvdXJjZUFscGhhIi8+DQogICAgICA8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxIiByZXN1bHQ9ImJsdXIiLz4NCiAgICAgIDxmZUZsb29kIGZsb29kLWNvbG9yPSIjNDQ1NjZjIiBmbG9vZC1vcGFjaXR5PSIwLjUwMiIvPg0KICAgICAgPGZlQ29tcG9zaXRlIG9wZXJhdG9yPSJpbiIgaW4yPSJibHVyIi8+DQogICAgICA8ZmVDb21wb3NpdGUgaW49IlNvdXJjZUdyYXBoaWMiLz4NCiAgICA8L2ZpbHRlcj4NCiAgPC9kZWZzPg0KICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLCAwLCAwLCAxLCAwLCAwKSIgZmlsdGVyPSJ1cmwoI092YWwpIj4NCiAgICA8Y2lyY2xlIGlkPSJPdmFsLTIiIGRhdGEtbmFtZT0iT3ZhbCIgY3g9IjYuNzUiIGN5PSI2Ljc1IiByPSI2Ljc1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDEpIiBmaWxsPSIjZmZmIi8+DQogIDwvZz4NCjwvc3ZnPg0K"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        tspan { white-space:pre }\n        .shp0 { fill: #d8d8d8 }\n        .shp1 { fill: #373737 }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG-3",
    className: "shp0",
    d: "M9 0L21 0C25.98 0 30 4.02 30 9L30 9C30 13.98 25.98 18 21 18L9 18C4.02 18 0 13.98 0 9L0 9C0 4.02 4.02 0 9 0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: BG-4",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BG-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    className: "shp1",
    d: "M0 0L30 0L30 18L0 18L0 0Z"
  })))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    href: "#img1",
    transform: "matrix(0.9,0,0,0.9,11,2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOn);
export default __webpack_public_path__ + "static/media/toggle-on.4ee4a750954b9a9654d9936bcc226d94.svg";
export { ForwardRef as ReactComponent };